module.exports = __webpack_public_path__ + "static/PAYGW_Tax Variation_–_Year_ending_30_June_2019-9cd87b9b2dc83cd36ff454438b718a72.pdf";